import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '../../../app/store';
import fetchAPI from "../../../common/fetchAPI";
import { WorkTypeStateClass } from "./interfaces/worktypeStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: WorkTypeStateClass = {
    isLoading: false,
    status: 'idle',
    worktypeList: [],
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'AccountWorkType',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        worktype: WorkTypeStateClass;
    },
}

export const getAccountWorkTypesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'worktype/v2/getAccountWorkTypes',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/WorkTypes', 'Get', '', true, '97889e4e-2d99-4309-b57c-8859dd9c346e');
            //console.log(response);
            const json = await response.json();
            return json;
        }
    )

export const getAccountWorkTypeByAccountWorkTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'worktype/v2/getAccountWorkTypeByAccountWorkTypeId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/WorkTypes/' + arg, 'Get', '', true, '97889e4e-2d99-4309-b57c-8859dd9c346e');
            const json = await response.json();
            return json;
        }
    )

export const addAccountWorkTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'worktype/v2/addWorkType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/WorkTypes/', 'POST', arg, true, '97889e4e-2d99-4309-b57c-8859dd9c346e');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountWorkTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'worktype/v2/updateAccountWorkType',
        async (arg, thunkApi) => {
            //const {AccountWorkTypeId} = arg;
            const { AccountWorkTypeId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/WorkTypes/' + AccountWorkTypeId, 'PUT', argWithoutId, true, '97889e4e-2d99-4309-b57c-8859dd9c346e');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountWorkTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'worktype/v2/deleteAccountWorkType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/WorkTypes/' + arg, 'DELETE', '', true, '97889e4e-2d99-4309-b57c-8859dd9c346e');
            const json = await response.json();
            return json;
        }
    )
export const DeleteSelectedAccountWorkTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "worktype/v2/DeleteSelectedAccountWorkType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/v2/Status/DeleteSelected/','Delete',arg,true,'0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/WorkTypes/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const worktypeSlice = createSlice({
    name: 'worktype',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.worktypeList.findIndex((item) => item.AccountWorkTypeId == action.payload);
            const newArray = [...state.worktypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.worktypeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.worktypeList.findIndex((item) => item.AccountWorkTypeId == action.payload);
            const newArray = [...state.worktypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.worktypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.worktypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.worktypeList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.worktypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.worktypeList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.worktypeList;
            state.worktypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountWorkTypesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountWorkTypesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                console.log('getAccountWorkTypesAsync:',payload.Data);
                // state.worktypeList = payload;
                if (Object.keys(payload.Data).length === 0) {
                    state.worktypeList = [];
                } else {
                    state.worktypeList = payload.Data;
                    state.worktypeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.selectedRecord = {};
                state.isLoading = false;

            })
            .addCase(getAccountWorkTypesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(getAccountWorkTypeByAccountWorkTypeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountWorkTypeByAccountWorkTypeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                console.log('payload.Data:',payload.Data);
                if (Object.keys(payload.Data).length === 0) {
                    state.selectedRecord = {};
                }
                else {
                    state.selectedRecord = payload.Data[0];
                    state.isLoading = false;

                }
                // state.selectedRecord = payload[0];
            })
            .addCase(getAccountWorkTypeByAccountWorkTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addAccountWorkTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountWorkTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountWorkTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(updateAccountWorkTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateAccountWorkTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updateAccountWorkTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteAccountWorkTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountWorkTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAccountWorkTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(DeleteSelectedAccountWorkTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountWorkTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountWorkTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

    }
})

export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updatePagination,updateSorting
} = worktypeSlice.actions
export const WorkTypeState = (state: RootState) => state.worktype
export default worktypeSlice.reducer
